module.exports = __webpack_public_path__ + "static/media/monster_death.12cfb9c5.mp3";